import StudyProgramCaseFormPageActionTypes from '../actions/study-program-case-form-page-action-types';

const initialState = {
  loading: false,
  studyProgramId: null,
  studyProgramCase: {},
  saveSuccess: false,
  validationResult: null,
  cancellationTokenSources: new Map()
};

export default (state = initialState, action) => {
  switch (action.type) {
    case StudyProgramCaseFormPageActionTypes.LOAD_STUDY_PROGRAM_CASE_FORM_PAGE_START:
      return {
        ...state,
        loading: true,
        validationResult: null
      };
    case StudyProgramCaseFormPageActionTypes.LOAD_STUDY_PROGRAM_CASE_FORM_PAGE_END:
      return {
        ...state,
        loading: false,
        studyProgramId: action.payload?.studyProgramId,
        studyProgramCase: action.payload ? action.payload.studyProgramCase : null,
        validationResult: action.payload ? action.payload.validationResult : null
      };
    default:
      return state;
  }
};